module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"dialogTitle":"Aggiorna Artist/Copyright"}}')
  delete Component.options._Ctor
}
